import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Blog: React.FC = () => {
  const posts = [
    {
      slug: 'best-temp-email-2025',
      title: 'Top Temporary Email Services for 2025: Why Our Service Stands Out',
      description: 'Explore the best temporary email services in 2025 and why our solution leads the industry.',
      date: '2024-03-21',
      image: 'https://images.unsplash.com/photo-1496096265110-f83ad7f96608?w=600&h=400&fit=crop'
    },
    {
      slug: 'why-you-need-temporary-email',
      title: 'Why You Need a Temporary Email: The Ultimate Guide to Email Privacy',
      description: 'Learn about the importance of temporary email services and how they can protect your privacy online.',
      date: '2024-03-15',
      image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=600&h=400&fit=crop'
    },
    {
      slug: 'smart-ways-use-temporary-email',
      title: '10 Smart Ways to Use Temporary Email for Online Security',
      description: 'Discover creative and effective ways to use temporary email services for enhanced online privacy.',
      date: '2024-03-16',
      image: 'https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=600&h=400&fit=crop'
    },
    {
      slug: 'how-to-use-temporary-email',
      title: 'How to Use Temporary Email: A Complete Guide',
      description: 'A comprehensive guide on how to effectively use temporary email services for maximum privacy.',
      date: '2024-03-17',
      image: 'https://images.unsplash.com/photo-1515378960530-7c0da6231fb1?w=600&h=400&fit=crop'
    },
    {
      slug: 'why-choose-our-service',
      title: 'Why Choose Our Temporary Email Service: A Comprehensive Comparison',
      description: 'Compare different temporary email services and discover why our solution stands out.',
      date: '2024-03-18',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop'
    },
    {
      slug: 'email-privacy-protection',
      title: 'Complete Guide to Email Privacy Protection',
      description: 'Learn everything about protecting your email privacy in the digital age.',
      date: '2024-03-19',
      image: 'https://images.unsplash.com/photo-1483706600674-e0c87d3fe85b?w=600&h=400&fit=crop'
    },
    {
      slug: 'social-media-email-protection',
      title: 'Protecting Your Privacy on Social Media with Temporary Email',
      description: 'How to maintain privacy on social media platforms using temporary email services.',
      date: '2024-03-20',
      image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=600&h=400&fit=crop'
    }
  ];

  return (
    <div className="w-[90%] max-w-7xl mx-auto px-4 py-12">
      <Helmet>
        <title>Blog | Secure Anonymous TempMail</title>
        <meta name="description" content="Learn about email privacy, security tips, and best practices for using temporary email services." />
        <meta name="keywords" content="temporary email blog, email privacy, secure email tips" />
      </Helmet>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {posts.map((post) => (
          <Link 
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="group h-full"
          >
            <article className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 h-full flex flex-col">
              <div className="aspect-w-3 aspect-h-2">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h2 className="text-xl font-bold text-gray-900 group-hover:text-primary-dark transition-colors duration-200 mb-3">
                  {post.title}
                </h2>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2 flex-1">
                  {post.description}
                </p>
                <div className="flex items-center text-sm text-gray-500 mt-auto">
                  <time dateTime={post.date}>
                    {new Date(post.date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </time>
                  <span className="mx-2">•</span>
                  <span>5 min read</span>
                </div>
              </div>
            </article>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Blog;